import React from 'react';

const Footer = () => (
  <div style={{
    background: '#333',
    color: '#fff',
    textAlign: 'center',
    padding: '14px',
    fontSize: 12,
  }}>
    2026 Copyright © Omkara Hostel. All Rights Reserved.
  </div>
);

export default Footer;